import { createRoute } from '@tanstack/solid-router'
import { appLayoutRoute } from '../app-layout.route'
import { SettingsPage } from '../../Views'

// `/account` — landing-страницы и Google OAuth (`post_login_url`) ведут сюда.
// SettingsPage по умолчанию открывает таб «Аккаунт» (см. createSignal('account')),
// так что отдельный компонент не нужен.
export const accountRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/account',
  component: SettingsPage,
})
